
import React from "react";
import "./SpecialEventCleaningService.css";

const SpecialEventCleaningService = () => {
  return (
    <div className="special-event-cleaning-container">
      <h1>Because Every Occasion Deserves a Flawless Setting</h1>
      <p>
        Hosting a celebration, gathering, or important event? Let us handle the cleaning
        so you can enjoy every moment without the stress. Our Special Event Cleaning service
        includes both pre-event and post-event options, ensuring your space is clean, welcoming,
        and picture perfect before and after the big day.
      </p>

      <h2>What’s Included:</h2>
      <p>We take care of the details so you can focus on your guests. A typical service includes:</p>
      <ul>
        <li>Pre-event dusting, vacuuming, and floor care</li>
        <li>Bathroom and kitchen refresh and sanitization</li>
        <li>Trash removal and bin relining throughout the event area</li>
        <li>Post event cleanup of surfaces, spills, and decorations</li>
        <li>Thorough vacuuming and mopping</li>
        <li>Final polish of high touch and high traffic areas</li>
      </ul>

      <h2>Why Choose Us for Special Event Cleaning?</h2>
      <ul>
        <li>🎉 <strong>Stress-Free Hosting</strong> – Focus on your event while we ensure everything looks spotless.</li>
        <li>📸 <strong>Event-Ready Results</strong> – We make your space shine for photos, videos, and guests.</li>
        <li>🧼 <strong>Reliable Before & After Cleaning</strong> – We handle both prep and cleanup efficiently.</li>
        <li>👗 <strong>Perfect for Homes & Venues</strong> – From private dinners to large celebrations.</li>
        <li>📅 <strong>Flexible Scheduling</strong> – Available evenings, weekends, and short-notice bookings.</li>
      </ul>
    </div>
  );
};

export default SpecialEventCleaningService;
